import { track } from "../../../analytics";
import ComponentWrapper from "./ComponentWrapper";
import Button from "../../Inputs/Button";
import { useRouter } from "next/router";

const Claim = (props) => {
  const { name, firmId, claimProfileUrl, render } = props;
  const router = useRouter();

  if (!render) return null
  
  const handleClaimButtonClick = () => {
    track("clicked_claim_button", {
      category: "firm_profile",
      firmId: firmId,
    });
    router.push(claimProfileUrl)
  };

  const renderClaim = () => (
    <div className="flex justify-between flex-wrap max-sm:text-center">
        <p className="text-cherry-red text-lg m-0 py-2 font-bold max-sm:basis-full">
          This profile is not yet managed by {name}.
        </p>

        <p className="text-lg m-0 py-2 font-bold max-sm:basis-full">Do you work at {name}?</p>

        <Button
          text='Claim your free profile'
          className='bg-cherry-red hover:bg-[#ec6c81] max-sm:basis-full max-sm:mt-2'
          onClick={handleClaimButtonClick}
          dataTest='claim-button'
        />
    </div>
  );

  return (
    <div className='bg-[#F3D3C7] py-5' data-test="claim-section">
      <ComponentWrapper>
        {renderClaim()}
      </ComponentWrapper>
    </div>
  );
};

export default Claim;
